import axios from 'axios'

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.common['rem-api-username'] = process.env.VUE_APP_API_USERNAME
axios.defaults.headers.common['rem-api-password'] = process.env.VUE_APP_API_PASSWORD
axios.defaults.headers.common['rem-api-secretkey'] = process.env.VUE_APP_API_SECRETKEY

export default axios
